export default __webpack_public_path__ + "static/media/ver-menos.0d1f6304.svg";